<template>
  <div class="bg-[#f8f8f8] md:px-8">
    <div class="max-w-7xl mx-auto w-full relative">
      <div class="py-10 flex flex-col justify-center gap-5">
        <div class="flex items-center justify-center px-5 md:px-0">
          <div class="flex-grow border-t-2 border-black"></div>
          <h2 class="px-4 text-[21px] lg:text-3xl text-[#001c54] text-center">
            #ItAllAddsUp
          </h2>
          <div class="flex-grow border-t-2 border-black"></div>
        </div>
        <!-- desktop -->
        <div class="hidden md:block mt-5">
          <div class="flex justify-between slick_des">
            <div class="" v-for="itall in italls" :key="itall">
              <div class="flex flex-col gap-2 shadow w-[200px] h-[180px] py-5">
                <img
                  :src="itall.image"
                  alt=""
                  class="w-[43px] h-[43px] mx-auto"
                />
                <p
                  v-html="itall.title"
                  class="tex-sm text-black h-[4rem] font-bold"
                ></p>
                <a
                  href="#applyBox"
                  class="bg-[#001c54] hover:bg-[#f8c300] hover:text-[#001c54] text-white py-2 px-2 w-[140px] mx-auto"
                >
                  Explore More
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- mobile -->

        <div class="md:hidden block">
          <div
            class="absolute bottom-0 right-0 top-[150px] md:top-[40%] md:right-0 z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/right-arrow.png"
              class="nextitall w-[30px] h-[30px]"
              width="30px"
              height="40px"
              alt=""
            />
          </div>
          <div class="flex justify-between slick_mob w-full">
            <div class="" v-for="itall in italls" :key="itall">
              <div
                class="flex flex-col gap-2 shadow w-[200px] mx-auto h-[180px]"
              >
                <img
                  :src="itall.image"
                  alt=""
                  class="w-[43px] h-[38px] mx-auto"
                />
                <p
                  v-html="itall.title"
                  class="tex-sm text-black h-[4rem] uppercase font-bold"
                ></p>
                <a
                  href="#applyBox"
                  class="bg-[#001c54] text-white py-2 px-2 w-[140px] mx-auto"
                >
                  Explore More
                </a>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 left-0 top-[150px] md:top-[40%] z-10 cursor-pointer"
          >
            <img
              src="@/assets/MbaFinance/left-arrow.png"
              width="30px"
              height="40px"
              class="previtall"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
export default {
  name: "ItalladdsView",
  data() {
    return {
      italls: [
        {
          id: 1,
          image: require("@/assets/LPnew/images/progfeatures/img2.png"),
          title: "Global<br>Curriculum ",
        },
        {
          id: 2,
          image: require("@/assets/LPnew/images/progfeatures/img3.png"),
          title: "Learning<br>Methodology ",
        },
        {
          id: 3,
          image: require("@/assets/LPnew/images/progfeatures/img4.png"),
          title: "25 Key Skills<br>for Success",
        },
        {
          id: 4,
          image: require("@/assets/LPnew/images/progfeatures/img5.png"),
          title: "Cutting-edge<br>Technology ",
        },
        {
          id: 5,
          image: require("@/assets/LPnew/images/progfeatures/img6.png"),
          title: "Personalised<br>Support ",
        },
        {
          id: 6,
          image: require("@/assets/LPnew/images/progfeatures/img7.png"),
          title: "Linkedin <br> Learning ",
        },
        {
          id: 7,
          image: require("@/assets/LPnew/images/progfeatures/img1.png"),
          title: "Credibility ",
        },
      ],
    };
  },
  mounted() {
    $(`.slick_mob`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: $(".previtall"),
      nextArrow: $(".nextitall"),
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
    }),
      $(`.slick_des`).slick({
        infinite: true,
        autoplay: true,
        prevArrow: false,
        nextArrow: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: true,
        responsive: [
          {
            breakpoint: 1026,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  },
};
</script>

<style></style>
